
import { HyperLinkBuilder, SimpleLinkRenderer } from "widgets/commonComponents/inline/hyperLink"
import { MenuItems } from "./audioHeaderComponenta"
import { SiteSimpleImage } from "../../../../commonComponents/inline/siteSimpleImage"


interface MainNavProps {
    navItems: MenuItems[]
    bgColor?: string
    termsLink?: string
    contactUsLink?: string
    accessibilityLink?: string
    logoUrl?: string
}
interface MainNavState {
    isOpened: boolean
}
export class AudioHeaderNavMutam extends React.Component<MainNavProps, MainNavState> {
    constructor(props) {
        super(props)
        this.state = {
            isOpened: false,
        }
    }
    private openMenu = () => {
        this.setState({ isOpened: true })
    }
    private closeMenu = () => {
        this.setState({ isOpened: false })
    }
    render() {
        const { navItems, bgColor, termsLink, contactUsLink, accessibilityLink, logoUrl } = this.props
        const { isOpened } = this.state


        return (
            <div className={`mainNav`} role="navigation" aria-label="Main Menu">
                <button className="menuHamburger" onClick={this.openMenu} />
                <div className={`navList ${isOpened ? "opened" : ""}`} style={{ background: bgColor }}>
                  <div className="navHeader">
                      <SiteSimpleImage src={logoUrl} />
                    <button className="closeMenu" onClick={this.closeMenu} />
                    </div>

                    <div className="mainNavListItems">
                        {_.map((navItems), (item: MenuItems, index: number) => 
                            <HyperLinkBuilder href={item.link} linkTarget={item.linkTarget} onClick={this.closeMenu} key={index}>
                                <SiteSimpleImage src={item.mobileUrl} />
                               <span >{item.title}</span>
                            </HyperLinkBuilder>
                       )}
                    </div>
                    <div className="navListItems">
                        <SimpleLinkRenderer href={termsLink} >תנאי שימוש</SimpleLinkRenderer>
                        <SimpleLinkRenderer href={accessibilityLink} >מדיניות פרטיות</SimpleLinkRenderer>
                        <SimpleLinkRenderer href={contactUsLink} >צרו קשר</SimpleLinkRenderer>

                    </div>
                    <div className="navFooter">
                        <a href="javascript:history.back()" className="goBack-footer" title="back" aria-label="חזור אחורה"></a>
                       <span> powered by ynet + Bi.Zi</span></div>

                </div>
            </div>
        )
    }
}